import { Student } from '@givebacks/api/student';
import { Avatar, Group, Stack, Text } from 'ui';

import { useStudentName } from '../../../hooks/useStudentName';

type StudentInfoCardProps = {
  student: Student;
};

const StudentInfoCard = ({ student }: StudentInfoCardProps) => {
  const studentName = useStudentName(student);
  return (
    <Group wrap="nowrap">
      <Avatar name={studentName} color="cobalt.5" size="48" />
      <Stack gap="4">
        <Text fw={500} fz="sm" lineClamp={4}>
          {studentName}
        </Text>

        <Text c="gray.6" size="10px">
          {student.cause.name} · Grade {student.grade}
        </Text>
      </Stack>
    </Group>
  );
};

export { StudentInfoCard };
